import React, { useEffect, useState } from "react";
import style from "./donation.module.css";
import { Col, Row } from "react-bootstrap";

import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";

import useGetUser from "../../customHook/useGetUser";
import { Helmet } from "react-helmet-async";

import { getToken } from "../../utils/api";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import {
  AdminPayment,
  createAdminSubscription,
} from "../../apis/paymentApis"
import Pray from "./pray";
const Adminpayment = () => {
  useGetUser();

  const navigate = useNavigate();

  const [amount, setSelectedAmount] = useState(""); // State for the selected amount radio button
  const [selectedFrequency, setSelectedFrequency] = useState("month"); // State for the selected frequency radio button
  const [id, setId] = useState("");
  const [usercomment, setUserComment] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState('');
  const handleAmountChange = (e) => {
    setSelectedAmount(e.target.value); // Update the selected amount
  };

  const handleFrequencyChange = (e) => {
    setSelectedFrequency(e.target.value); // Update the selected frequency
  };

   const dispatch = useDispatch();

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check this out!",
          text: "I found this amazing content. Have a look!",
          url: window.location.href, // Current page URL
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      alert("Sharing is not supported on your browser.");
    }
  };

    const handleDonate = () => {
    if (!amount) {
      toast.error("Please select a  amount for proceed the payment");
      return;
    }
    if (!email) {
      toast.error("Please enter the email address");
      return;
    }
    if (!fullName) {  // ← ADD THIS
  toast.error("Please enter your full name");
  return;
}

    const clearamount = amount.replace(/,/g, "");

    if (!isNaN(clearamount) && Number(clearamount) >= 0) {
       if (selectedFrequency == "1") {
        dispatch(
          AdminPayment({
            amount: amount,
            email: email,
            fullName: fullName,
            id: id,
            usercomment: usercomment
          })
        ).then((res) => {
          if (res?.data) {
            window.location.href = res?.data;
          }
        });
      } else {
        dispatch(
          createAdminSubscription({
            amount: amount,
            interval: "month",
            email: email,
            fullName: fullName,
            id: id,
          usercomment: usercomment
          })
        ).then((res) => {
          if (res?.url) {
            window.location.href = res?.url;
          }
        });
      }
    } else {
      toast.error("Invalid amount. Please enter a valid number.");
      return;
    }
  };

    localStorage.setItem("email", email);
  localStorage.setItem("amount", amount);
  localStorage.setItem("fullName", fullName); 


  useEffect(() => {

    const token = getToken();
    if (token) {
      const decoded = jwtDecode(token);
      setId(decoded?.sub);
    }
  }, []);


  return (
    <>
      <Helmet>
        <title>Donate-to-us - Fund Life</title>
        <meta
          name="description"
          content="Support our mission by choosing a donation amount and frequency. Help ensure those in need are not forgotten. Your generosity matters!"
        />
        <meta
          property="og:description"
          content="Support our mission by choosing a donation amount and frequency. Help ensure those in need are not forgotten. Your generosity matters!"
        />
        <meta
          name="keywords"
          content="Donation amount,Custom donation,Donation frequency,One-time donation,Monthly donation,Checkout,Thank you,Financial contribution,Support,Charitable giving"
        />
      </Helmet>
      <div className={style.donationcontainer}>
        <div className="container">
          <div className={style.admininforcol}>
            <h1 className={style.supportadmin}>Support the Global Life Fund</h1>
            <Row>
              <Col md={6}>
                <div className={style.adminamountdonationmain}>
                  <div className={style.labellinkmain}>
                    Enter a custom donation amount
                  </div>

                  <div className={style.customAmountInputdonation}>
                    <span className={style.currencydonation}>$</span>

                    <input
                      type="text"
                      value={amount}
                      placeholder="Enter custom amount"
                      onChange={(e) => setSelectedAmount(e.target.value)}
                      className={style.inputboxtextdonation}
                    />
                  </div>
                  <div className={style.labellinkemailmain}>Enter Name</div>

                  <div className={style.customAmountInput}>
                    <input
                      type="text"
                      placeholder="Full name"
                      value={fullName}
                      onChange={(e) => setFullName(e.target.value)}
                      className={style.informationinputdonationmain}
                    />
                  </div>



                  <div className={style.labellinkemailmain}>Enter Email</div>

                  <div className={style.customAmountInput}>
                    <input
                      type="email"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className={style.informationinputdonationmain}
                      disabled={isLoggedIn} // Disable if logged in
                    />
                  </div>
                  <div className={style.labellinkemailmain}>Add a comment (optional)</div>
                  <div className={style.customAmountInput}>
                    <input
                      placeholder="Write your comment..."
                      value={usercomment}
                      onChange={(e) => setUserComment(e.target.value)}
                      className={style.informationinputdonationmain}
                      rows={3}
                    />
                  </div>
                </div>
              </Col>

              <Col md={6}>
                 <div className={style.adminpaymentformmaindonation}>
                  <div className={style.paymentFormdonation}>
                    <div className={style.donationpaymentmain}>
                      <h3>Choose a donation frequency</h3>
                      <div className={style.donateradiomain}>
                        <div
                          className={
                            selectedFrequency === "1"
                              ? style.adminselectedLabel2main
                              : style.labeldonatemain
                          }
                        >
                          <div className={style.donationlabelmain}>
                            <label className={style.labelcontent}>
                              <input
                                type="radio"
                                name="frequency"
                                value="1"
                                checked={selectedFrequency === "1"}
                                onChange={handleFrequencyChange}
                                className={style.customRadio} // ✅ custom class here
                              />

                              <span>OneTime</span>
                            </label>
                          </div>
                        </div>

                        <div
                          className={
                            selectedFrequency === "month"
                              ? style.adminselectedLabel2main
                              : style.labeldonate2main
                          }
                        >
                          <div className={style.donationlabelmain}>
                            <label className={style.labelcontent}>
                              <input
                                type="radio"
                                name="frequency"
                                value="month"
                                checked={selectedFrequency === "month"}
                                onChange={handleFrequencyChange}
                                className={style.customRadio}
                              />

                              <span>Monthly</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className={style.admindonationbuttoncontainermain1}>
                        <div className={style.smallscreenabutton}>
                          <button
                            onClick={handleDonate}
                          >
                            <img src="/logosstripe.png"></img>
                          </button>
                        </div>
                      </div>
                      <div>
                        <div className={style.admindonationbuttoncontainermain} style={{ flex: '1' }}>
                          <div className={style.smallscreenabutton}>
                            <button onClick={handleShare}>
                              Share
                            </button>
                          </div>
                        </div>
                        <div style={{ flex: '1' }}>
                          <Pray centerId={id} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

            </Row>
          </div>
        </div>
      </div>
  
    </>
  );
};

export default Adminpayment;
